/**
 * 通用文案 —— 中文（源语言）
 * key = 中文原文；en-US/common.ts 必须逐条对应
 */
export default {
  // ---- 通用按钮 ----
  '确定': '确定',
  '取消': '取消',
  '关闭': '关闭',
  '新增': '新增',
  '编辑': '编辑',
  '删除': '删除',
  '保存': '保存',
  '提交': '提交',
  '搜索': '搜索',
  '重置': '重置',
  '刷新': '刷新',
  '返回': '返回',
  '上传': '上传',
  '下载': '下载',
  '预览': '预览',
  '详情': '详情',
  '更多': '更多',
  '导出': '导出',
  '导入': '导入',
  '确认': '确认',
  '展开': '展开',
  '收起': '收起',
  '复制': '复制',
  '全部': '全部',

  // ---- 通用字段 ----
  '状态': '状态',
  '操作': '操作',
  '标题': '标题',
  '类型': '类型',
  '名称': '名称',
  '备注': '备注',
  '分类': '分类',
  '排序': '排序',
  '金额': '金额',
  '关键词': '关键词',
  '描述': '描述',
  '内容': '内容',
  '简介': '简介',
  '图片': '图片',
  '链接': '链接',
  '角色': '角色',
  '企业': '企业',
  '管理员': '管理员',
  '权限': '权限',
  '用户': '用户',
  '账号': '账号',
  '密码': '密码',
  '手机号': '手机号',
  '姓名': '姓名',
  '联系人': '联系人',
  '企业名称': '企业名称',
  '英文名称': '英文名称',
  '创建时间': '创建时间',
  '更新时间': '更新时间',
  '分站域名': '分站域名',
  '推荐': '推荐',

  // ---- 状态值 ----
  '启用': '启用',
  '禁用': '禁用',
  '停用': '停用',
  '正常': '正常',
  '未知': '未知',
  '待审核': '待审核',
  '已驳回': '已驳回',
  '处理中': '处理中',
  '成功': '成功',
  '失败': '失败',
  '是': '是',
  '否': '否',

  // ---- 提示语 ----
  '操作成功': '操作成功',
  '操作失败': '操作失败',
  '删除成功': '删除成功',
  '删除失败': '删除失败',
  '保存成功': '保存成功',
  '保存失败': '保存失败',
  '创建成功': '创建成功',
  '更新成功': '更新成功',
  '加载中': '加载中',
  '暂无数据': '暂无数据',
  '网络错误': '网络错误',
  '确定删除': '确定删除',
  '请选择': '请选择',
  '请输入': '请输入',
  '提示': '提示',
  '警告': '警告',
  '错误': '错误',
  '记得点保存': '记得点保存',
  '绑定企业': '绑定企业',
  '解绑': '解绑',

  // ---- 登录 ----
  '登录': '登录',
  '退出登录': '退出登录',
  '验证码': '验证码',
  '忘记密码': '忘记密码',
  '记住我': '记住我',
  '请输入手机号': '请输入手机号',
  '请输入密码': '请输入密码',
  '请输入验证码': '请输入验证码',
  '获取验证码': '获取验证码',
  '手机号或密码错误': '手机号或密码错误',
  '登录成功': '登录成功',
  '登录失败': '登录失败',
  '正在登录': '正在登录',

  // ---- 站点 ----
  '企庭管理系统': '企庭管理系统',
  '管理后台': '管理后台',

  // ---- 第二批补充：带标点的提示 / 更多通用词 ----
  '确定删除？': '确定删除？',
  '上传图片': '上传图片',
  '选择文件': '选择文件',
  '请求失败': '请求失败',
  '参数错误': '参数错误',
  '未登录': '未登录',
  '登录已过期': '登录已过期',
  '无权限': '无权限',
  '加载失败': '加载失败',
  '重试': '重试',
  '查看': '查看',
  '修改': '修改',
  '设置': '设置',
  '配置': '配置',
  '列表': '列表',
  '总数': '总数',
  '保存并发布': '保存并发布',
  '已启用': '已启用',
  '已禁用': '已禁用',
  '保存中': '保存中',
  '提交中': '提交中',
  '清空': '清空',
  '批量删除': '批量删除',
  '启用成功': '启用成功',
  '禁用成功': '禁用成功',
  '添加': '添加',
  '生效': '生效',
  '失效': '失效',
  '上线': '上线',
  '下线': '下线',
  '公开': '公开',
  '隐藏': '隐藏',
  '置顶': '置顶',
  '发布': '发布',
  '撤回': '撤回',
  '审核': '审核',
  '驳回': '驳回',
  '通过': '通过',
  '拒绝': '拒绝',
  '说明': '说明',
  '单位': '单位',
  '数量': '数量',
  '价格': '价格',
  '时间': '时间',
  '日期': '日期',
  '来源': '来源',
  '作者': '作者',
  '手机号不能为空': '手机号不能为空',
  '密码不能为空': '密码不能为空',
};
